export { default as ClipboardButton } from './ClipboardButton';